(function(){
'use strict';
var opener=null;
function openDoc(id,from){
  var d=document.getElementById(id);
  if(!d||d.tagName!=='DIALOG'||typeof d.showModal!=='function')return false;
  var cur=document.querySelector('dialog.rx-doc[open]');
  if(cur===d)return true;
  if(cur)cur.close();else opener=from||document.activeElement;
  d.showModal();
  var b=d.querySelector('.rx-doc-body');if(b)b.scrollTop=0;
  return true;
}
function hashOf(a){var h=a.getAttribute('href')||'';return h.charAt(0)==='#'?decodeURIComponent(h.slice(1)):'';}
document.addEventListener('click',function(e){
  var t=e.target;
  var btn=t.closest('[data-rx-doc]');
  if(btn){openDoc(btn.getAttribute('data-rx-doc'),btn);return;}
  var a=t.closest('a');
  var h=a?hashOf(a):'';
  if(h.indexOf('rx-doc-')===0){if(openDoc(h,a))e.preventDefault();return;}
  var x=t.closest('[data-rx-doc-close]');
  if(x){x.closest('dialog').close();return;}
  if(t.matches('dialog.rx-doc')){
    var r=t.getBoundingClientRect();
    if((e.clientX||e.clientY)&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))t.close();
    return;
  }
  if(a&&h&&a.closest('dialog.rx-doc')){
    var target=document.getElementById(h),dlg=a.closest('dialog');
    if(!target)return;
    e.preventDefault();
    if(dlg.contains(target)){target.scrollIntoView({block:'start'});return;}
    opener=null;
    dlg.close();
    target.scrollIntoView({block:'start'});
    return;
  }
  var buy=t.closest('[data-rgx-bp-btn]');
  if(buy){
    var form=document.querySelector('.rgx-hero form.rgx-form');
    if(!form)return;
    if(form.requestSubmit)form.requestSubmit();else form.querySelector('[data-rgx-cta]').click();
    return;
  }
  if(t.closest('[data-rgx-bp-chg]')){
    var tiers=document.querySelector('.rgx-tiers');
    if(tiers)tiers.scrollIntoView({block:'center',behavior:'smooth'});
  }
});
[].forEach.call(document.querySelectorAll('dialog.rx-doc'),function(d){
  d.addEventListener('close',function(){
    if(document.querySelector('dialog.rx-doc[open]'))return;
    var back=opener;opener=null;
    if(back&&document.contains(back)&&!back.closest('dialog'))back.focus();
  });
});
var cta=document.querySelector('.rgx-hero [data-rgx-cta]');
var meta=document.querySelector('.rgx-hero [data-sticky-meta]');
var btns=document.querySelectorAll('[data-rgx-bp-btn]');
var sels=document.querySelectorAll('[data-rgx-bp-sel]');
function sync(){
  if(!cta)return;
  [].forEach.call(btns,function(b){b.innerHTML=cta.innerHTML;b.disabled=cta.disabled;});
  if(meta&&meta.textContent)[].forEach.call(sels,function(s){s.textContent=meta.textContent;});
}
if(cta&&btns.length){
  sync();
  new MutationObserver(sync).observe(cta,{childList:true,subtree:true,characterData:true,attributes:true});
  var form=cta.closest('form');
  if(form)form.addEventListener('change',function(){setTimeout(sync,0);});
}
var sticky=document.querySelector('.rgx-hero [data-rgx-sticky]');
if(sticky){
  var near=new Set();
  function place(){
    var p=document.getElementById('PBarNextFrameWrapper');
    var lift=p?Math.round(p.getBoundingClientRect().height):0;
    sticky.style.bottom=lift?lift+'px':'';
    var show=sticky.classList.contains('is-visible')&&!near.size;
    sticky.style.transform=show?'none':'translateY(calc(100% + '+(lift+12)+'px))';
  }
  new MutationObserver(place).observe(sticky,{attributes:true,attributeFilter:['class']});
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){
      en.forEach(function(e){if(e.isIntersecting)near.add(e.target);else near.delete(e.target);});
      place();
    },{threshold:.2});
    [].forEach.call(document.querySelectorAll('[data-rgx-bp]'),function(p){io.observe(p);});
  }
  place();setTimeout(place,1500);setTimeout(place,4000);
}
})();
